import { render, staticRenderFns } from "./TopicsMobileHeader.vue?vue&type=template&id=7c6e4c45&scoped=true"
import script from "./TopicsMobileHeader.vue?vue&type=script&lang=js"
export * from "./TopicsMobileHeader.vue?vue&type=script&lang=js"
import style0 from "./TopicsMobileHeader.vue?vue&type=style&index=0&id=7c6e4c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6e4c45",
  null
  
)

export default component.exports